export default {
  title: 'Master Sky Shot',
  // 首页卡片样片上那颗「看样片」药丸按钮
  videoPill: {
    watchSample: 'Preview',
  },
  appMenu: {
    title: 'Menu',
    scan: 'Scan',
    language: 'Language',
    notice: 'Messages',
    service: 'Support',
    setting: 'Settings',
  },
  tabBar: {
    aerial: 'Fly',
    masterMap: 'Master Map',
    home: 'Home',
    memory: 'Memories',
    profile: 'Me',
    order: 'Orders',
    exchange: 'EXCH',
    community: 'Community',
    noDataPopup: {
      title: 'No Check-in Point',
      content: 'Please scan QR codes at other check-in points',
    },
    spotNotMatch: {
      title: 'Order Not Valid Here',
      content: 'Please scan at the original check-in point',
    },
    success: {
      title: 'Order Matched',
      content: 'No active orders available~',
    },
    fail: {
      title: 'Order Match Failed',
      content: 'Rescan or contact customer service~',
    },
    livestreamFail: {
      title: 'Aerial Failed',
      content:
        'Due to flight restrictions, your order will be refunded automatically. Please check notifications.',
    },
    notHotspotQrcode: 'Invalid QR Code',
    exceededUsageTime: 'Time Expired',
    expiredTicket: 'Current status cannot be used',
  },
  homePage: {
    noHotspotNearby: 'No spots nearby yet — try another location',
    matchingNearby: 'Finding the nearest spots for you…',
    matchedNearby: 'Sorted by distance from you',
    nearerSpot: '{name} is {gain} closer',
    nearerSpotPlain: '{name} is closer to you',
    nearerSpotAction: 'Take a look',
    allAirlines: 'All Routes',
    distanceAbout: 'About {distance} away',
    routeDisplay: 'Route',
    noRouteData: 'No route data for this flight',
    nearestSession: 'Shoot time',
    bookingLocking: 'Holding your slot',
    bookingCreated: 'Order created',
    bookingPaying: 'Opening payment',
    bookingHint: 'Please keep this page open',
    today: 'Today',
    tomorrow: 'Tomorrow',
    sessionDate: 'Date',
    sessionTime: 'Time',
    hotspotIndex: 'Hotspot {index} of {total}',
    swipeForMore: 'Swipe down for more',
    alreadyBottom: "You're at the end",
    alreadyTop: "You're at the top",
    pullToRefresh: 'Keep pulling to refresh',
    releaseToRefresh: 'Release to refresh',
    refreshing: 'Refreshing',
    refreshDone: 'Refreshed',
    noSessionToday: 'Fully booked today',
    attractionCard: {
      loginToReservation: 'Login to Book',
      workingTime: 'Business Hours',
    },
    checkinCard: {
      desc: 'Started~',
      buttonText: 'Fly Now',
    },
    orderPopup: {
      desc: 'Your scheduled flight has started~',
      buttonText: 'Start Flight',
    },
    loginTipsBar: {
      desc: 'Login to unlock full features',
      buttonText: 'Login',
    },
    runningJourneyTipsBar: {
      desc: 'You have an active flight',
      buttonText: 'Join',
    },
    selectFlightPage: {
      reservationAndSelect: 'Pick a date & time',
      sessionBooked: 'Fully booked',
      selectFlight: 'Choose Route',
      flightDesc: 'Includes: 3-5min flight, gestures, 10 photos',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      toChangeTicket: 'To Change Ticket',
      toExchange: 'To Exchange',
      confirmReservation: 'Book Now',
      timeType: {
        morning: 'Sunrise',
        noon: 'Noon',
        afternoon: 'Afternoon',
        evening: 'Sunset',
        night: 'Starry Night',
      },
      reserved: 'Booked',
      selected: 'Selected',
      soldOut: 'Sold Out',
      soldOutToday: 'Sold Out Today',
      deviceUnavailable: 'Unavailable',
      theParisianText: {
        confirmReservation: "Can't be booked online",
        tips: 'Please contact staff on site',
      },
      paymentPopup: {
        desc: 'Arrive <span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">5 mins early</span>.<br />Enter Order Page and tap 【Fly Now】 or 【Scan Aerial】;<br />If there is staff on site, please ask them for assistance.',
        desc2:
          'Please <span style="color: #FFF; font-size: 1.4rem; font-weight: 700; margin:0 0.8rem">5 mins early</span> to the hotspot.<br />Ask staff for assistance.',
      },
      verifyPopup: {
        title: 'Verify Code',
        desc: 'Limited availability. Get verification code from staff.',
        placeholder: '6-digit code',
      },
      paymentUpdatePopup: {
        title: 'Payment Upgrade',
        desc: 'Please order in WeChat/Alipay mini-program',
      },
      otherBrowserPopup: {
        title: 'Go to Mini Program',
        desc: 'Please use the mini program to book and experience the Master Sky Shot service',
      },
    },
  },
  memoryPage: {
    title: 'Memories',
    checkYourRecordAfterLogin: 'Login to view memories',
    noHotpot: 'No records yet',
    video: 'Videos',
    photo: 'Photos',
    zhang: '',
    duan: '',
    photoProcessing: 'Processing',
    photoProcessingError: 'Error',
    photoProcessingExpired: 'Timeout',
    unlockMore: 'Unlock More',
    moreTemplate: 'More Templates',
    publish: 'Publish to Community',
    publishPlaceholder: 'Share your feelings and let more people know~',
    publishSuccess: 'Publish Success',
    publishFailed: 'Publish Failed',
    noRecord: 'No records yet',
    unlockToExperienceText:
      'Experience aerial photography for free, unlock all features if satisfied',
    hdPhotoText: 'HD Photos',
    unlockToGetText: 'Unlock to get',
    mediaResultCodeMap: {
      ORIGINAL_VIDEO: 'Original Video',
      ORIGINAL_PIC: 'Original Photo',
      CLIP_FAST_VIDEO: 'Quick Video',
      PREVIEW_VIDEO: 'Preview Video',
      VIDEO_SUCCESS: 'Trimmed Video',
      VIDEO_SUCCESS_BEAUTY: 'Trimmed Video',
      FIX_CLIP: 'Mixed Clip',
      FIX_CLIP_BEAUTY: 'Mixed Clip',
      PAY_TEMP_VIDEO: 'Luxury Clip',
      PAY_TEMP_VIDEO_BEAUTY: 'Luxury Clip',
    },
    unlockedMedia: {
      title: 'Current Unlocked',
      desc1: 'You have unlocked HD photos',
      desc2: ', can download',
    },
    lockedMedia: {
      title: 'Unlock More',
      desc1: 'all rights',
      desc2: 'In statistics',
    },
    hotpotDetailPage: {
      title: 'Memory Details',
      processing: 'Processing',
      videoProcessing: 'Processing',
      videoError: 'Error. Pull to refresh',
      videoFail: 'Failed. Contact support',
      videoLost: 'Video lost',
      noVideo: 'No Video',
      photoProcessing: 'Processing',
      photoEmpty: 'No photos',
      noMemory: 'No memories',
      downloadPhoto: 'Long-press to save/share~',
      pullrefresh: 'Pull to refresh',
      pullrefreshing: 'Refreshing',
      easyRefresh: 'Release',
      refreshSuccess: 'Refreshed',
      sampleVideo: 'Sample',
    },
    videoPage: {
      title: 'Download',
      downloading: 'Downloading',
      click: 'Tap top-right',
      openInBrower: 'Open in browser',
      text: 'Download video here',
    },
    cancelPublish: {
      title: 'Are you sure to cancel?',
      desc: 'It will not be displayed in "Community"',
      skipText: 'Not now',
    },
    playbackLimit: {
      title: 'Complete payment on detail page',
      desc: 'Claim HD photos / beautiful videos',
      confirmText: 'Detail page',
    },
    sharePopup: {
      title: 'Shared Memories',
      desc: 'Invite friends to scan the code and transfer this memory to their account~',
      desc2: 'Valid for 14 days after completion of flight.',
    },
    createPoster: {
      poster: 'Poster',
      choosePhoto: 'Choose Photo',
      chooseTemplate: 'Poster Templates',
      quoteTitle: 'Caption',
      inputPlaceholder: 'Write your moment here~',
      generate: 'Generate Poster',
      generating: 'Generating...',
      pleaseChoosePhoto: 'Please choose a photo',
      templateLoading: 'Loading templates...',
      templateEmpty: 'No templates',
      photoEmpty: 'No photos',
      shareFriend: 'Share',
      downloadPoster: 'Download',
      close: 'Close',
      posterAlt: 'Generated Poster',
      bgAlt: 'Background Image',
      templateAlt: 'Template Image',
      shareNotSupported: 'Sharing is not supported. Please download and share.',
      generateFailed: 'Failed to generate poster. Please try again later.',
    },
    memoryItem: {
      trimmedVideo: 'Trimmed Video',
      trimmedVideoDescription: 'Watch 10 seconds for free ・ Unlock to view full video + download',
      quickVideo: 'Quick Video',
      quickVideoDescription: 'Watch full video for free ・ Unlock to download',
      experienceVoucher: 'Experience Voucher',
      experienceVoucherPopup: {
        subTitle: 'Try aerial photography for free. Pay to unlock all features if satisfied.',
        skipBtnText: 'Cancel',
        confirmBtnText: 'Unlock',
        benefitsTable: {
          type: 'Type',
          locked: 'Locked',
          unlocked: 'Unlocked',
          photoTitle: 'Photo Rights',
          photoLockedLine1: 'Download complimentary photos',
          photoUnlockedLine1: 'Download all HD photos',
          photoUnlockedLine2: 'Unlimited access',
          videoTitle: 'Video Rights',
          videoLockedLine1: '10s preview only,',
          videoLockedLine2: 'Cannot download video',
          videoUnlockedLine1: 'Full trimmed + quick videos',
          videoUnlockedLine2: '(Full download)',
          posterTitle: 'Poster',
          posterLocked: 'Poster feature unavailable',
          posterUnlocked: 'Many poster templates, one-click to generate posters',
          communityTitle: 'Community',
          communityLocked: 'Cannot post to community',
          communityUnlocked: 'Can post to community and share highlights',
        },
      },
      videoEnded: {
        playEndedText: 'Play completed',
        unlockToDownloadText: 'Unlock to download video',
        unlockToGetVideoAndDownloadText: 'Unlock to get video download',
        unlockToWatchText: 'Unlock to watch full video + download',
        replayText: 'Replay video',
        unlockText: 'Unlock now',
        contactText: 'Contact staff to unlock',
      },
    },
  },
  orderPage: {
    title: 'Orders',
    checkOrderAfterLogin: 'Login to view orders',
    noOrder: 'No orders',
    noClipOrder: 'No orders',
    flightOrders: 'Flight',
    videoOrders: 'Video',
    orderId: 'OID',
    paid: 'Paid',
    fullRefund: 'Full refund',
    partialRefund: 'Fee {value}%, refund',
    shadow: 'Unpaid',
    orderDetailPage: {
      title: 'Order Details',
      goThere: 'Navigate',
      paymentTime: 'Paid at',
      exchangeTime: 'Exchanged at',
      startTime: 'Starts',
      endTime: 'Ends',
      refundDetails: 'Refund',
      paymentDetails: 'Payment',
      refundPrice: 'Refund',
      totalPrice: 'Total',
      partialRefund: 'Fee {value}% applies',
      changeTicketLimit: 'Max reschedules',
      awaitingUseNote: {
        title: 'Pending',
      },
      usedNote: {
        title: 'Completed',
        desc: 'Thank you for flying with us',
      },
      expiredNote: {
        title: 'Expired',
        desc: 'Check-in time passed',
      },
      unfinishedNote: {
        title: 'Incomplete',
        desc: 'Reschedule to retry',
      },
      cancelledNote: {
        title: 'Canceled',
        desc: 'Weather refund issued',
      },
      refundsProgressNote: {
        title: 'Refunding',
        desc: 'Processing refund',
      },
      refundFailureNote: {
        title: 'Refund Failed',
        desc: 'Not eligible',
      },
      refundedNote: {
        title: 'Refunded',
        desc: 'Check payment method',
      },
      deviceErrorNote: {
        title: 'Incomplete',
        desc: 'Flight interrupted</br>Auto-refund processing',
      },
      skypathNotFound: 'Route offline',
      refundApplicationPopup: {
        title: 'Refund Request',
        dontWanaUse: 'Change of plans',
        nonFlyable: 'Weather/restriction/equipment failure',
        unusedOvertime: 'Missed timeslot',
        hazardousConditions: 'Emergency abort',
        systemCancel: 'System failure',
        explanation: 'Details',
        detailsDesc: 'Explain for faster processing',
        uploadPicture: 'Upload',
        parentheses: '(Improves approval, max 4)',
        longText: 'Emergency aborts qualify for full refunds. Processing takes 7-10 days.',
        cancelledText:
          'Aerial shoot failed due to system issues. After approval, your payment will be refunded.',
      },
      quesstionPopup: {
        title: 'Confirm Refund?',
        subTitle: '{value}% fee applies.Proceed?',
      },
      feedbackPopup: {
        title: 'Submitted',
        subTitle: 'Processing',
        description: 'After approval, your refund will be returned within 7 business days.',
      },
    },
    orderStatus: {
      NOTIFICATION_TYPE_UNKNOWN: 'Unknown',
      TICKET_TYPE_UNSPECIFIED: 'Unknown',
      TICKET_TYPE_NEW: 'Pending',
      TICKET_TYPE_COMPLETED: 'Completed',
      TICKET_TYPE_ABORTED: 'Completed',
      TICKET_TYPE_CHECKED: 'Pending',
      TICKET_TYPE_EXPIRED: 'Expired',
      TICKET_TYPE_CANCELLED: 'Incomplete',
      TICKET_TYPE_DRC_INIT_FAILED: 'Incomplete',
      TICKET_TYPE_LIVE_STREAM_FAILED: 'Incomplete',
      TICKET_TYPE_LIVE_STREAM_PUSHED: 'Active',
      TICKET_TYPE_BAD_WEATHER: 'Canceled',
      TICKET_TYPE_REFUND_REQUESTED: 'Refunding',
      TICKET_TYPE_REFUND_REJECTED: 'Refund Failed',
      TICKET_TYPE_REFUND_ACCEPTED: 'Refunded',
      TICKET_TYPE_SHADOW: 'Unpaid',
      UNKNOWN: 'Unknown',
      UNPAID: 'Unpaid',
      UNUSED: 'Pending',
      USED: 'Used',
      EXPIRED: 'Expired',
      REFUNDING: 'Refunding',
      REFUNDED: 'Refunded',
      REFUND_REJECTED: 'Refund Failed',
      LIVE_STREAM_PUSHED: 'Active',
      CHECKED: 'Checked',
      UNFINISHED: 'Incomplete',
    },
    clipOrderStatus: {
      EDIT_PENDING: 'Editing',
      EDIT_COMPLETED: 'Completed',
    },
  },
  profilePage: {
    switchLanguage: 'Language',
    clickLogin: 'Login',
    service: 'Support',
    referrer: 'Referral',
    becomeReferrerPopup: {
      title: 'Become Referrer',
      subTitle: 'Earn rewards for new user orders.',
    },
    canceledReferrerPopup: {
      title: 'Revoked',
      subTitle: 'Contact support for help.',
    },
    referrerToast: {
      pendingReview: 'Processing',
      submitSuccess: 'Submitted',
      toMiniProgramUse: 'Use mini-program',
      toMiniProgramSettle: 'Settle in mini-program',
    },
    referrerReviewStatus: {
      PENDING: 'Reviewing',
      REJECTED: 'Rejected',
      CANCELLED: 'Revoked',
      DISABLED: 'Revoked',
    },
    userQrcodePopup: {
      share: ['Tap top-right', 'to share'],
      tip: 'Scan to join Master Sky Shot',
    },
    bindShareMemoryPopup: {
      title: 'You have an unexperienced flight',
      buttonText1: 'Try Aerial Now',
      buttonText2: 'Claim existing videos/photos',
    },
    claimSuccessPopup: {
      title: 'Claim Successful',
      desc: 'Videos/photos have been saved to "My Memories".',
    },
    SHARE_EXIST: {
      title: 'Memory Already Claimed',
      desc: 'You have already claimed this memory. No need to claim it again.',
      icon: 'normal',
    },
    SHARE_OWN_MEMORY_FORBIDDEN: {
      title: 'Claim Notice',
      desc: "You can't claim your own memory (video/photo).",
      icon: 'warning',
    },
    SHARE_ORDER_STATUS_ERROR: {
      title: 'Claim Notice',
      desc: "You can't claim memories (videos/photos) from this order.",
      icon: 'warning',
    },
    SHARE_EXPIRED: {
      title: 'Claim Expired',
      desc: 'The 14-day claim period has expired, unable to claim~',
      icon: 'error',
    },
    claimFailedPopup: {
      title: 'Claim Failed',
      desc: 'Sorry, the claim period has ended.',
    },
    notice: 'Notifications',
    setting: 'Settings',
    wechatUser: 'WeChat User',
    anonymousUser: 'Anonymous User',
    toutiaoUser: 'Douyin User',
    aliUser: 'Alipay User',
    phoneNumberText: 'Authorize phone via WeChat',
    exchangeInputError: 'Invalid code',
    exchangeInputPlaceholder: 'Enter code',
    scanQRCodeFailed: 'Scan failed',
    servicePopup: {
      title: 'Support',
      desc: 'Long-press QR code<br />for dedicated service',
    },
    loginPopup: {
      content: 'Login to view',
    },
    noticePage: {
      title: 'Notifications',
      viewDetails: 'Details',
      successfulBooking: 'Booked',
      orderCanceled: 'Canceled',
      refundRequestSubmittedSuccessfully: 'Refund Requested',
      refundRequestFailed: 'Refund Failed',
      refundRequestApproved: 'Refund Approved',
      noNotice: 'No notifications',
      noticeDetailsPage: {
        title: 'Details',
      },
    },
    switchLanguagePage: {
      title: 'Language',
      switchComplete: 'Switched',
    },
    settingPage: {
      title: 'Settings',
      account: 'Account',
      about: 'About',
      changePhoneNumber: 'Change Phone',
      serviceAgreement: 'Terms',
      privacyPolicy: 'Privacy',
      AboutMss: 'About MSS',
      writeoffAccount: 'Delete Account',
      popup: {
        title: 'Confirm Deletion?',
        subTitle: 'This action is irreversible. Note:',
        deregisteredSuccessfully: 'Deleted',
        contenth3: 'All data will be erased:',
        contentp1: '1.Personal info, orders, flight media will be permanently deleted.',
        contentp2: '2.No refunds for processed transactions.',
      },
    },
    serviceAgreementPage: {
      title: 'Terms',
    },
    privacyPolicyPage: {
      title: 'Privacy',
    },
    aboutMssPage: {
      title: 'About MSS',
      desc: 'Shared Drone System for Tourism:<br />Fully automated aerial services.',
      slogan: 'Show the beauty of China to the world',
    },
    changePhoneNumberPage: {
      title: 'Change Phone',
      newPhoneNumber: 'New number',
      verifyCurrentPhone: 'Verify current number',
      originalPhoneNumber: 'Original number',
      modifyPhoneBinding: 'Bind new number',
      modifyPhoneBindingSuccess: 'Success',
      tips: 'Next step unbinds current number',
      successToast: {
        title: 'Changed',
      },
      errorToast1: {
        title: 'Number taken',
      },
      errorToast2: {
        title: 'SMS error',
      },
    },
  },
  loginPage: {
    loginLoad: 'Logging in...',
    loginByWechat: 'WeChat Login',
    acceptInvitationLogin: 'Accept Invite',
    noLogin: 'Skip',
    weChatAuthorizedLogin: 'WeChat Auth',
    phoneLogin: 'Phone Login',
    phoneLoginTips: 'New user verification login is registration',
    tipsText: 'I agree to',
    userAgreement: '"Terms"',
    privacyPolicy: '"Privacy"',
    verificationCodeSend: 'Code sent',
    verificationCodeExpired: 'Code expired',
    verificationCodeError: 'Wrong code',
    netWorkError: 'Network anomaly, please try again later',
    popup: {
      title: 'Agreements',
      content:
        'Please agree to our&nbsp;&nbsp;<span style="color: #016BFF"><span class="_terms">Terms</span> & <span class="_privacy">Privacy</span></span>',
    },
    referrer: {
      title: 'Inviter',
      notNewUser: 'Not eligible',
      success: 'Invite accepted',
      unableInviteMyself: "Can't invite self",
    },
    smsCodePopup: {
      title: 'Please use the previous SMS code to login',
      subTitle: 'SMS code limit reached',
    },
  },
  bindingPhonePage: {
    tips: 'First login requires phone binding',
    phone: 'Input phone number',
    verificationCode: 'Input verification code',
    getCode: 'Get Code',
    getCodeAgain: 'Resend',
    bindingPhone: 'Bind Phone',
    phoneError: 'Invalid number',
    areaCodeError: 'Invalid area code',
    noMatchCountry: 'No matching country',
    searchAreaCode: 'Search area code',
    unbindPhoneError: 'Number mismatch',
    verificationCodeError: 'Wrong code',
    successToast: {
      title: 'Bound',
    },
    toast1: {
      title: 'Number taken',
      content: 'Use another number',
    },
    toast2: {
      title: 'Invalid code',
      content: 'Request new code',
    },
  },
  wechatPage: {
    title: 'Use WeChat to access<span style="color: #42BDFF">Master Sky Shot</span>',
    desc1: 'Scan check-in QR codes via WeChat.',
    desc2: 'Screenshot this page and identify QR code in WeChat.',
  },
  tutorialsPage: {
    step1: {
      title: 'Pre-flight',
      description: 'Stand within marked area for best experience',
    },
    step2: {
      title: 'Photography',
      description1: 'Swipe to adjust camera angle.',
      description2: 'Drag to zoom.',
      description3: 'Best Angle',
      description4: 'Tap to reset to optimal frame.',
      description5: 'Preparing',
      description6: 'Capture',
      description7: '3s countdown starts',
    },
    step3: {
      title: 'Live Guide',
      description: 'Increase volume for voice guidance',
    },
    step4: {
      title: 'Emergency Stop',
      description1: 'Tap "Stop" to abort flight.',
      description2: 'Progress saves to Memories.',
      description3: 'Auto-aborts qualify for refunds.',
    },
    tutorialsPopup: {
      title: 'Pre-flight~',
      subTitle: 'Stand within marked area</br>for best experience',
      buttonText: "I'm ready",
    },
    guideline: 'Guide',
    yourReservation: 'Your Flight',
    started: 'Started',
    asaPossible: 'Start ASAP',
    yourReservationStill: 'Time left',
    keepInMind: 'Starts',
  },
  aerialPage: {
    resume: {
      flying: 'Flight in progress',
      flyingWithTime: 'Flight in progress · {time}',
      backToFlight: 'Back to flight',
    },
    TAKE_OFF: 'Takeoff',
    GO_HOME: 'Return',
    FLYING: 'Flying',
    RECORDING: 'Recording',
    USER_PHOTO: 'Selfie',
    CONTROL: 'Control',
    SYSTEM_PHOTO: 'Auto-capture',
    HOVERING_CONTROL: 'Hovering Control',
    PREPARE_FOR_TAKE_OFF: 'Takeoff Preparation',
    DRONE_STARTUP: 'Drone Startup',
    DOCK_COVER_OPEN: 'Dock Cover Open',
    TOUCH_SCREEN_SHOW_LIVE: 'Tap to view',
    LIVE_SUCCESS: 'Live connection successful',
    POOR_NETWORK_TOUCH_RECONNECT: 'Poor connection - Tap to retry',
    seizePower: 'Control lost',
    seizePowerBtn: 'Retake control',
    connecting: 'Connecting...',
    airportLive: {
      connecting: 'Airport connecting',
      poorNetwork: 'Poor network - Auto retry',
    },
    step1: {
      name: 'Takeoff',
    },
    step2: {
      name: 'Selfie',
    },
    step3: {
      name: 'Flight',
    },
    shotTips: 'Capturing',
    flightPoints: 'Route nodes',
    flightInitTips: 'Initializing',
    flightRecordTips: 'Flight is being recorded; manual recording unavailable.',
    flightFinishPopup: {
      statusText: 'Flight completed',
      subTitle:
        'Media processing in<span style="color: #FFF; font-size: 1.8rem; font-weight: 700; line-height: 2.6rem; margin:0 0.8rem">10 mins</span><br />Check Memories later~',
      subscribedText: 'Notify me',
    },
    flightErrorPopup: {
      statusText: 'Flight Failed',
      subTitle: 'Please <span style="color: #016BFF">Reschedule</span> or request refund.',
      confirmBtnText: 'Reschedule',
      cancelBtnText: 'Refund',
    },
    autoTakePhotoText: 'Preparing<br />auto-capture~',
    networkAnomalyPopup: {
      title: 'Connection Error',
      subTitle: 'Network issue detected<br />Reconnect or restart',
      confirmBtnText: 'Retry',
    },
    stopFlightPopup: {
      title: 'Abort Flight?',
      subTitle: 'Progress saves to Memories.',
      content: 'No refunds for aborts',
    },
    droneStartFailPopup: {
      title: 'Launch Failed',
      subTitle: 'Airport issue - Retry later!',
    },
    droneLowBattery: {
      title: 'Launch Failed',
      subTitle: 'Drone charging - Retry later!',
    },
    terminateFlightPopup: {
      title: 'Emergency Stop',
      subTitle: 'Safety abort initiated.<br />Refund available.',
      content: 'Request in Orders',
    },
    droneExecutingPopup: {
      title: 'Launch Failed',
      subTitle: 'Drone busy - Retry later!',
      cancelBtnText: 'Back',
      confirmBtnText: 'Retry',
    },
    thisLineFlyingPopup: {
      title: 'Launch Failed',
      subTitle: 'Route busy - Retry later!',
      cancelBtnText: 'Back',
      confirmBtnText: 'Retry',
    },
    noRtkPopup: {
      title: 'Launch Failed',
      subTitle: 'Airport not calibrated - Retry later!',
      cancelBtnText: 'Back',
      confirmBtnText: 'Retry',
    },
    autoReturnPopup: {
      title: 'Auto-Return',
      subTitle: 'Route error.<br /><span style="color: #016BFF">Reschedule</span> or refund.',
      skipBtnText: 'Auto-ends',
    },
    recoveryFailPopup: {
      title: 'Route Lost',
      subTitle: 'Drone off-course.<br /><span style="color: #016BFF">Reschedule</span> or refund.',
      skipBtnText: 'Auto-ends',
    },
    takeOffFailedPopup: {
      title: 'Launch Failed',
      subTitle: 'System error - Auto-refunded!',
    },
    takeOffNoHeartbeatPopup: {
      title: 'Launch Failed',
      subTitle: 'Airport offline - Auto-refunded!',
    },
    takeOffNoFilePopup: {
      title: 'Launch Failed',
      subTitle: 'Route error - Auto-refunded!',
    },
    autoRefundPopup: {
      title: 'Launch Failed',
      subTitle: 'Order almost timeout - Auto-refunded!',
    },
    unKnownPopup: {
      title: 'Launch Failed',
      subTitle: 'System busy - Retry later!',
    },
    beforeScheduledTimePopup: {
      title: 'Launch Failed',
      subTitle: 'Too early. Retry later.',
    },
    liveStreamFailedPopup: {
      title: 'Launch Failed',
      subTitle: 'Stream error - Retry later!',
    },
    noInTaskPopup: {
      title: 'Drone returning',
      subTitle: 'Previous task completed, returning to dock, please wait!',
    },
    moreThanOneMinuteFailedPopup: {
      title: 'Launch Failed',
      subTitle: 'Airport issue - <span style="color: #016BFF">Reschedule</span>!',
      cancelBtnText: 'Reschedule',
      confirmBtnText: 'Retry',
    },
    lessThanOneMinuteFailedPopup: {
      title: 'Launch Failed',
      subTitle:
        'Order Almost timeout - <span style="color: #016BFF">Reschedule</span>!<br />Or request refund.',
      cancelBtnText: 'Refund',
      confirmBtnText: 'Reschedule',
    },
    notCompleteStartPopup: {
      title: 'Aerial Photography Failed',
      subTitle: 'Sorry, an automatic refund will be issued to your account.',
    },
    skipFlightPopup: {
      title: 'Skip Node?',
      subTitle: 'Skipped nodes become unavailable',
      content: 'Confirm carefully',
      confirmBtnText: 'Continue',
      cancelBtnText: 'Skip',
    },
    flightDescription: {
      default: 'Initializing - Please wait~',
      d0: 'Drone launching',
      d1: 'Positioning',
      d2: 'Ready',
    },
    loadingToast: {
      photo: 'Capturing',
      recording: 'Recording',
      exit: 'Exiting',
    },
    switchText: {
      takePhoto: 'Selfie',
      control: 'Control',
    },
    SKYSHOT_JOURNEY_INTERRUPTED: 'Airport issue - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_LIVE_STREAM_FAILED:
      'Stream error - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED:
      'Stream error - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_EXECUTING: 'Drone busy - Retry later!',
    SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH:
      'Low battery - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_TAKEOFF_FAILED:
      'Command error - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT:
      'Airport offline - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_TAKEOFF_NO_FILE:
      'Route error - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_UNKNOWN: 'System busy - Retry later!',
    SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT:
      'Device offline - <span style="color: #016BFF">Reschedule</span>!',
    SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT:
      'Airport offline - <span style="color: #016BFF">Reschedule</span>!',
    // Not a network fault: the route and the dock point at different agents, so
    // neither retrying nor rescheduling helps - it needs a config fix (mss-cloud#66)
    SKYSHOT_JOURNEY_AGENT_DOCK_NOT_BOUND:
      'Route unavailable - please contact on-site staff!',
    // Dock is online but has no drone bound - also a config gap (mss-cloud#93 / h5#24)
    SKYSHOT_JOURNEY_DOCK_DRONE_NOT_BOUND:
      'No drone linked to this dock - please contact on-site staff!',
    TAKE_OFF_TIME_OUT: 'Takeoff timeout - <span style="color: #016BFF">Reschedule</span>!',
    START_FLY_CMD_FAIL: 'Start fly cmd fail - <span style="color: #016BFF">Reschedule</span>!',
    DRONE_NOT_IN_DOCK: 'Drone not in dock - <span style="color: #016BFF">Reschedule</span>!',
    PICK_DOCK_FAIL: 'Connect dock fail - <span style="color: #016BFF">Reschedule</span>!',
    DJI_UPLOAD_LOG: 'Airport uploading log - <span style="color: #016BFF">Reschedule</span>!',
    stillTime: 'Time left',
    shootInSuccession: 'Burst',
    joystickControl: {
      up: 'Up',
      down: 'Down',
      left: 'Left',
      right: 'Right',
    },
    droneControl: {
      up: 'Forward',
      down: 'Backward',
      left: 'Left',
      right: 'Right',
    },
    liveQuality: 'Live</br>Quality',
    liveQualityValue: {
      auto: 'Auto',
      smooth: 'Smooth',
      standard: 'Standard',
      hd: 'HD',
      uhd: 'UHD',
    },
    controlTheGimbal: 'Swipe to control the gimbal',
    pausedControlTheGimbal: 'Paused, enter hovering control',
    gimbal: 'Gimbal',
    refresh: 'Refresh',
    interrupted: 'Interrupted',
    live: 'Live',
  },
  actionsPage: {
    actionResolutionFail: 'Action error',
    paramsResolutionFail: 'Parameter error',
  },
  personalPage: {
    title: 'Profile',
    signature: {
      title: 'Edit Signature',
      placeholder: 'This person is cool and has not written a signature',
    },
  },
  community: {
    title: 'Comment',
    likeFailed: 'Like failed, please try again',
    unlikeFailed: 'Unlike failed, please try again',
    commentTitle: 'Post Comment',
    commentPlaceholder: 'Share your thoughts...',
    commentSuccess: 'Comment posted successfully',
    commentFailed: 'Failed to post comment, please try again',
    noComment: 'No comments yet~',
    shootSimilar: 'Shoot similar',
  },
  common: {
    waylineSummary: {
      title: 'Includes',
      desc: '3-5min flight, gestures, 10 photos',
    },
    unknownError: 'Error',
    expand: 'More',
    collect: 'Less',
    hotspot: 'Hotspot',
    copy: 'Copy',
    copySuccess: 'Copied',
    copyFailed: 'Failed',
    verifySuccess: 'Verified',
    verifyFailed: 'Failed',
    loadError: 'Load failed. Tap to retry',
    loadFailed: 'Failed to load',
    retry: 'Retry',
    useDate: 'Use Date',
    useTime: 'Use Time',
    date: 'Date',
    time: 'Time',
    noMore: 'No more~',
    noData: 'No data',
    noContent: 'No content~',
    unset: 'Not set',
    experienceNow: 'Experience',
    alreadyExperience: 'Done',
    myMemory: 'My Memories',
    purchaseNotes: {
      title: 'Notes',
      note1: 'Arrive 5 mins early;',
      note2:
        'Enter Order Page and tap 【Fly Now】 or 【Scan Aerial】;<br />If there is staff on site, please ask them for assistance.',
      note3: 'No refunds for late arrivals.',
      note4: 'Please ask staff for assistance.',
      note5: 'Use time 5 mins before/after slot. e.g. 8:15 = 8:10-8:20.',
      note6: 'No access 5 mins after slot.',
    },
    refundRules: {
      title: 'Refund Policy',
      refundRequestTimeToUse: 'Time before flight',
      unusedOvertime: 'Missed slot (within 7 days)',
      unusedOvertime2: 'Missed slot (after 7 days)',
      otherReason: 'Weather/restrictions/equipment failure',
      handlingFee: 'Fee',
      verification: 'Verified',
      noRefund: 'No refunds',
    },
    termsOfUse: {
      title: 'Guidelines',
      howToUse: {
        title: 'Usage',
        description:
          'Enter Order Page and tap 【Fly Now】 or 【Scan Aerial】;<br />If there is staff on site, please ask them for assistance.',
        description2: 'Please ask staff for assistance.',
      },
      timeOfUse: {
        title: 'Timing',
        description: '5 mins before/after slot. e.g. 8:15 = 8:10-8:20.',
        description2: 'Use time 5 mins before/after slot. e.g. 8:15 = 8:10-8:20.',
      },
      timeoutUnused: {
        title: 'Late Policy',
        description: 'No access 5 mins after slot.',
        description2: 'No access 5 mins after slot.',
      },
      changeTicket: {
        title: 'Rescheduling',
        description: '1. 5 free reschedules max.<br />2. No refunds after 7 days.',
      },
    },
    servicePopup: {
      title: 'WeChat Support',
      content: 'Long-press QR code<br />for dedicated service',
    },
    authFailedPopup: {
      title: 'Session Expired',
      subtitle: 'Please relogin.',
    },
    accountFrozenPopup: {
      title: 'Account Frozen',
      subtitle: 'Violation detected!</br>Contact support.',
    },
    h: 'h',
    m: 'm',
    hour: 'hour',
    hourShort: 'h',
    minuteShort: 'm',
    minute: 'min',
    day: 'day',
    ago: 'ago',
    just: 'just',
    more: 'More',
    about: '~',
    paymentSuccessful: 'Booked',
    changeTicketSuccess: 'Rescheduled',
    changeTicketFailed: 'Reschedule failed',
    exchangeSuccess: 'Redeemed',
    exchangeFailed: 'Failed',
    exchangeFailedDescription: 'No memory video/photo available yet, please try again later.',
    exchangeFailedDescriptionExpired: 'This coupon has expired, please use other coupons.',
    sessionNotAvailable: 'Slot taken',
    subscribe: 'Notify',
    subscribed: 'Subscribed',
    subscribeLoad: 'Subscribing...',
    subscribeError: 'Failed',
    paymentSuccessfulSubscribe: 'Notify me',
    current: 'Now',
    backToToday: 'Back to<br />Today',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec',
    male: 'Male',
    female: 'Female',
    hide: 'Hide',
    nickname: 'Name',
    phone: 'Phone',
    gender: 'Gender',
    saveSuccess: 'Saved',
    saveFailed: 'Failed',
    pleaseTryAgain: 'Retry',
    requestFailed: 'Click to reload',
    loading: 'Loading',
    mapLoading: 'Loading map',
    mapLoadFailed: 'Map failed to load',
    bg: 'BG',
    pullUpLoadMore: 'Pull to load',
    scan: 'Scan',
    scanSubTitle: 'Place QR code in frame to scan',
    weixin: 'WeChat',
    alipay: 'Alipay',
    signature: 'Signature',
    originalVideo: 'Original Video',
    originalImage: 'Original Image',
    publishedCommunity: 'Published',
    publishToCommunity: 'Publish',
    disabledPublishCommunity: "Can't publish",
    viewOriginalImage: 'View Original Image',
    viewThumbnail: 'Rendering',
    later: 'Later',
  },
  buttonText: {
    confirm: 'OK',
    cancel: 'Cancel',
    back: 'Back',
    backTryAgain: 'Retry',
    nextStep: 'Next',
    reservation: 'Book Now',
    confirmChangeTicket: 'Reschedule',
    confirmExchange: 'Redeem',
    viewOrder: 'Orders',
    aerialPhotographyGuide: 'Guide',
    agreeAndLogin: 'Agree & Login',
    toLogin: 'Login',
    loginToReserve: 'Login to Book',
    reserveNow: 'Book Now',
    downloadVideo: 'Download',
    downloading: 'Downloading',
    downloadAgain: 'Retry',
    download: 'Download',
    share: 'Shared',
    gotIt: 'Got it',
    requestRefund: 'Refund',
    contactCustomerService: 'Support',
    noApplication: 'Later',
    submitApplication: 'Submit',
    logout: 'Logout',
    confirmSwitching: 'Confirm',
    completionBonding: 'Bind',
    agreeAndBind: 'Agree & Bind',
    login: 'Login',
    notApply: 'Cancel',
    identifyAndApply: 'Confirm',
    thinkAbout: 'Cancel',
    definitiveCancellation: 'Delete',
    startupAerial: 'Launch',
    aerialInfoSynchronized: 'Syncing',
    viewMemory: 'Memories',
    breakAerial: 'Abort',
    breakAerialBr: 'Abort<br />Flight',
    continueAerial: 'Continue',
    scanRightNow: 'Fly Now',
    oneClickAerial: 'Fly Now',
    scanAerial: 'Scan Aerial',
    enterAerial: 'Enter',
    toChangeTicket: 'To Change Ticket',
    changeTicket: 'Change Ticket',
    rescanQrcode: 'Rescan',
    noStream: 'Lag<br />Tap me',
    confirmModification: 'Confirm',
    skip: 'Skip',
    prev: 'Prev',
    next: 'Next',
    voucher: 'Redeem',
    longPressSaveQrcode: 'Long-press to save',
    saveImage: 'Save',
    shareFriends: 'Share',
    exchange: 'Redeem',
    toAppointment: 'Book',
    appointmentShoot: 'Change time',
    shootNow: 'Book next slot',
    purchase: 'Buy',
    gain: 'Get',
    loginToBook: 'Login to Book',
  },
  bookingCard: {
    oneClickStart: 'Start',
    loginToBook: 'Login',
    bookNow: 'Book',
    scanAerial: 'Scan',
    contactStaff: 'Contact',
    moreOrders: 'Orders',
  },
  other: {
    exitPreview: 's exit preview',
  },
  countries: {
    // Asia
    china: 'China',
    hongkong: 'Hong Kong',
    taiwan: 'Taiwan',
    macau: 'Macau',
    singapore: 'Singapore',
    japan: 'Japan',
    thailand: 'Thailand',
    malaysia: 'Malaysia',
    philippines: 'Philippines',
    australia: 'Australia',
    india: 'India',
    southkorea: 'South Korea',
    vietnam: 'Vietnam',
    indonesia: 'Indonesia',
    myanmar: 'Myanmar',
    cambodia: 'Cambodia',
    laos: 'Laos',
    brunei: 'Brunei',
    mongolia: 'Mongolia',
    kazakhstan: 'Kazakhstan',
    kyrgyzstan: 'Kyrgyzstan',
    uzbekistan: 'Uzbekistan',
    tajikistan: 'Tajikistan',
    turkmenistan: 'Turkmenistan',
    afghanistan: 'Afghanistan',
    pakistan: 'Pakistan',
    bangladesh: 'Bangladesh',
    srilanka: 'Sri Lanka',
    maldives: 'Maldives',
    nepal: 'Nepal',
    bhutan: 'Bhutan',
    iran: 'Iran',
    iraq: 'Iraq',
    israel: 'Israel',
    jordan: 'Jordan',
    lebanon: 'Lebanon',
    syria: 'Syria',
    saudiarabia: 'Saudi Arabia',
    uae: 'UAE',
    qatar: 'Qatar',
    kuwait: 'Kuwait',
    bahrain: 'Bahrain',
    oman: 'Oman',
    yemen: 'Yemen',

    // Europe
    russia: 'Russia',
    uk: 'United Kingdom',
    france: 'France',
    germany: 'Germany',
    italy: 'Italy',
    spain: 'Spain',
    portugal: 'Portugal',
    netherlands: 'Netherlands',
    belgium: 'Belgium',
    switzerland: 'Switzerland',
    austria: 'Austria',
    sweden: 'Sweden',
    norway: 'Norway',
    denmark: 'Denmark',
    finland: 'Finland',
    poland: 'Poland',
    czech: 'Czech Republic',
    hungary: 'Hungary',
    romania: 'Romania',
    bulgaria: 'Bulgaria',
    croatia: 'Croatia',
    serbia: 'Serbia',
    slovenia: 'Slovenia',
    slovakia: 'Slovakia',
    estonia: 'Estonia',
    latvia: 'Latvia',
    lithuania: 'Lithuania',
    greece: 'Greece',
    turkey: 'Turkey',
    ukraine: 'Ukraine',
    belarus: 'Belarus',
    moldova: 'Moldova',
    albania: 'Albania',
    macedonia: 'Macedonia',
    montenegro: 'Montenegro',
    bosnia: 'Bosnia',
    ireland: 'Ireland',
    iceland: 'Iceland',
    luxembourg: 'Luxembourg',
    malta: 'Malta',
    cyprus: 'Cyprus',
    monaco: 'Monaco',
    liechtenstein: 'Liechtenstein',
    andorra: 'Andorra',
    sanmarino: 'San Marino',
    vatican: 'Vatican',

    // North America
    us: 'United States',
    canada: 'Canada',
    mexico: 'Mexico',
    guatemala: 'Guatemala',
    belize: 'Belize',
    honduras: 'Honduras',
    elsalvador: 'El Salvador',
    nicaragua: 'Nicaragua',
    costarica: 'Costa Rica',
    panama: 'Panama',
    cuba: 'Cuba',
    jamaica: 'Jamaica',
    haiti: 'Haiti',
    dominican: 'Dominican Republic',
    puertorico: 'Puerto Rico',

    // South America
    brazil: 'Brazil',
    argentina: 'Argentina',
    chile: 'Chile',
    colombia: 'Colombia',
    peru: 'Peru',
    venezuela: 'Venezuela',
    ecuador: 'Ecuador',
    bolivia: 'Bolivia',
    paraguay: 'Paraguay',
    uruguay: 'Uruguay',
    guyana: 'Guyana',
    suriname: 'Suriname',
    frenchguiana: 'French Guiana',

    // Africa
    southafrica: 'South Africa',
    egypt: 'Egypt',
    nigeria: 'Nigeria',
    kenya: 'Kenya',
    morocco: 'Morocco',
    algeria: 'Algeria',
    tunisia: 'Tunisia',
    libya: 'Libya',
    sudan: 'Sudan',
    ethiopia: 'Ethiopia',
    ghana: 'Ghana',
    tanzania: 'Tanzania',
    uganda: 'Uganda',
    zimbabwe: 'Zimbabwe',
    zambia: 'Zambia',
    botswana: 'Botswana',
    namibia: 'Namibia',
    angola: 'Angola',
    mozambique: 'Mozambique',
    madagascar: 'Madagascar',
    mauritius: 'Mauritius',
    seychelles: 'Seychelles',
    comoros: 'Comoros',
    djibouti: 'Djibouti',
    somalia: 'Somalia',
    eritrea: 'Eritrea',
    rwanda: 'Rwanda',
    burundi: 'Burundi',
    malawi: 'Malawi',
    lesotho: 'Lesotho',
    swaziland: 'Swaziland',
    cameroon: 'Cameroon',
    centralafrica: 'Central African Republic',
    chad: 'Chad',
    congo: 'Congo',
    democraticcongo: 'Democratic Republic of Congo',
    gabon: 'Gabon',
    equatorialguinea: 'Equatorial Guinea',
    sao: 'São Tomé and Príncipe',
    guinea: 'Guinea',
    guineabissau: 'Guinea-Bissau',
    sierraleone: 'Sierra Leone',
    liberia: 'Liberia',
    ivorycoast: 'Ivory Coast',
    burkinafaso: 'Burkina Faso',
    mali: 'Mali',
    niger: 'Niger',
    senegal: 'Senegal',
    gambia: 'Gambia',
    capeverde: 'Cape Verde',
    mauritania: 'Mauritania',

    // Oceania
    newzealand: 'New Zealand',
    fiji: 'Fiji',
    papuanewguinea: 'Papua New Guinea',
    solomon: 'Solomon Islands',
    vanuatu: 'Vanuatu',
    newcaledonia: 'New Caledonia',
    frenchpolynesia: 'French Polynesia',
    samoa: 'Samoa',
    tonga: 'Tonga',
    kiribati: 'Kiribati',
    tuvalu: 'Tuvalu',
    nauru: 'Nauru',
    palau: 'Palau',
    marshall: 'Marshall Islands',
    micronesia: 'Micronesia',
    cookislands: 'Cook Islands',
    niue: 'Niue',
    tokelau: 'Tokelau',
    pitcairn: 'Pitcairn Islands',

    // Caribbean
    saintlucia: 'Saint Lucia',
    saintvincent: 'Saint Vincent and the Grenadines',
    americansamoa: 'American Samoa',
    saintkitts: 'Saint Kitts and Nevis',
    dominica: 'Dominica',
    britishvirginislands: 'British Virgin Islands',
    sintmaarten: 'Sint Maarten',
    turksandcaicos: 'Turks and Caicos Islands',
    usvirginislands: 'U.S. Virgin Islands',

    // Special regions and islands
    jersey: 'Jersey',
    guernsey: 'Guernsey',
    isleofman: 'Isle of Man',
    alandislands: 'Åland Islands',
    svalbard: 'Svalbard',
    mayotte: 'Mayotte',
    northmacedonia: 'North Macedonia',
    southsudan: 'South Sudan',
    saintpierre: 'Saint Pierre and Miquelon',
    guadeloupe: 'Guadeloupe',
    saintmartin: 'Saint Martin',
    saintbarthelemy: 'Saint Barthélemy',
    sinteustatius: 'Sint Eustatius',
    saba: 'Saba',
    bonaire: 'Bonaire',
    curacao: 'Curaçao',
    easttimor: 'East Timor',
    wallisandfutuna: 'Wallis and Futuna',
    falklandislands: 'Falkland Islands',
  },
}
